import React, { Component } from 'react'
import moment from 'moment'
import { Col, Row, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import { translate } from 'react-translate'

@translate("ImiItem")
export default class ImiItem extends Component {

  _renderDate(date){
    moment.locale('es');
    var m = moment(date, "MM-DD-YYYY");
    let day = moment(m).format('MMMM')
    let year = moment(m).format('YYYY')
    return (
      <div className="transform-date">
        <p className="week-day">{day}</p><p>{year}</p>
      </div>
    )
  }

  render () {

    const {id, slug, image, date, file, t } = this.props

    var style = {
      backgroundImage: 'url(' + image + ')'
    }

    return (
    	<div className="imi-container">
        <Link to={'/informes-del-mercado-inmobiliario/' + slug}>
          <div className="img-container" style={style}>
            <div className="overlay-imi"></div>
          </div>
        </Link>
        <div className="info-container">
          <h3 className="imi-title">{this._renderDate(date)}</h3>
          <Link to={'imi/' + slug}><Button className="btn-download hidden-xs">{t("Ver_informe")}</Button></Link>
          <Link to={'imi/' + slug}><Button className="btn-download visible-xs">{t("Ver_informe")}</Button></Link>
        </div>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Imi/item.js